import { createReactQueryHooks } from '@trpc/react';
import type { AppRouter } from '../../../backend/src/trpc/index';

export const trpc = createReactQueryHooks<AppRouter>();